module.exports = __webpack_public_path__ + "img/V3.57799e0c.jpg";